import styled from 'styled-components'

export const TooltipIconWrap = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  text-align: center;
  border-radius: 16px;
  cursor: pointer;
  background: ${(props) => props.theme.palette.default};
  color: ${(props) => props.theme.palette.muted};
`
